<template>
  <div class="footer-main">
    <div class="message">
      <div class="message-title">现在留言将获取一份专业项目诊断报告</div>
      <div class="message-box">
        <el-form :model="form" ref="formModifyRow" :rules="rules">
          <el-form-item :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}" prop="enterpriseName">
            <el-input
              v-model="form.enterpriseName"
              placeholder="企业名称（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="name" :rules="{required: true, message: '不能为空', trigger: ['blur', 'change']}">
            <el-input
              v-model="form.name"
              placeholder="姓名（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item prop="telephone" :rules="[{required: true, message: '请输入手机号', trigger: ['blur', 'change']},
                {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '格式不正确', trigger: ['blur', 'change']}]">
            <el-input
              v-model="form.telephone"
              placeholder="联系电话（必填）"
              class="message-inp"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="message-btn"  @click="submitRow()">立即提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
    <div class="footer-box">
      <div class="footer-m">
        <el-row>
          <el-col :span="8">
            <div class="corporate">
              <p class="corporate-title">联系我们</p>
              <p class="corporate-title">广州渠道无忧网络技术服务有限公司</p>
              <p class="contact-way">电话：020-29884285 / 18026284260</p>
              <p class="contact-way">QQ：1164290938</p>
              <p class="contact-way">微信：wangdiannaijing</p>
              <p class="contact-way">地址：广州市白云区机场路1962号国际单位一期e栋202</p>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="corporate">
              <!--<p class="corporate-title">联系我们</p>-->
              <!--<p class="contact-way">招商智投</p>-->
              <!-- <p class="contact-way">
                <a href="http://www.show-q.com/" target="_blank">
                  品牌全案
                </a>
              </p> -->
              <!--<p class="contact-way">全网营销</p>-->
            </div>
          </el-col>
          <el-col :span="4">
            <!--<div class="corporate">
              <router-link :to="'/learning-and-support'">
                <p class="corporate-title" @click="changeStatus(0)">学习与支持</p>
              </router-link>
              <router-link :to="'/learning-and-support'">
                <p class="contact-ways"  @click="changeStatus(0)">常见问题</p>
              </router-link>
              <router-link :to="'/learning-and-support'">
                <p class="contact-ways" @click="changeStatus(1)">规则中心</p>
              </router-link>
            </div>-->
          </el-col>
          <el-col :span="8">
            <!--<div class="corporate">
              <el-row>
                <el-col :span="8">
                  <p class="corporate-title">扫码关注我们的微信公众号</p>
                  <div class="code">
                    <img src="../../../assets/images/qudao.png"/>
                  </div>
                  <p class="code-title">渠道无忧</p>
                </el-col>
              </el-row>
            </div>-->
          </el-col>
        </el-row>
      </div>
      <div class="foot-link"></div>
      <div class="copyright">Copyright © 2013-2019 qudaowuyou. All Rights Reserved 广州渠道无忧网络技术服务有限公司</div>
      <div class="serial">
        <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011102000534" target="_blank" style="margin-right:10px;"><img src="@/assets/images/police_icon.png" width="14" height="14" style="margin:2px 3px 0 0;">粤公网安备 44011102000534号</a>
        <a href="https://beian.miit.gov.cn/#/Integrated/index"  target="_blank">粤ICP备13036846号</a>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import { FormArgument } from '@/models/customer-good'
  import Api from '@/api/customer-good'
  export default {
    components: {},
    data () {
      return {
        table: {
          list: []
        },
        form: new FormArgument()
      }
    },
    methods: {
      submitRow () {
        this.$refs['formModifyRow'].validate((valid) => {
          if (valid) {
            let name = this.form.name
            let enter = this.form.enterpriseName
            let phone = this.form.telephone
            if (name !== '' && name !== undefined && enter !== '' && enter !== undefined && phone !== '' && phone !== undefined) {
              let form = this.form
              form.type = 2
              form.platform = 1
              if (this.$store.state.user.info !== null) {
                Api.createLogin({form: form}, response => {
                  let status = response.status || 0
                  let body = response.data || []
                  if (status >= 200 && status <= 204) {
                    // 新数据加到数组开头
                    this.table.list.unshift(body)
                    this.$message.success('留言成功')
                  } else {
                    this.$message.error(body.error || '留言失败')
                  }
                  // 关闭
                  this.$refs['slideModifyRow'].close()
                })
                this.form = []
              } else {
                Api.create({form: form}, response => {
                  let status = response.data.code
                  let body = response.data
                  if (status === '200') {
                    // 新数据加到数组开头
                    this.table.list.unshift(body.data)
                    this.$message.success('留言成功')
                  } else {
                    this.$message.error(body.msg || '留言失败')
                  }
                  // 关闭
                  this.$refs['slideModifyRow'].close()
                })
                this.form = []
              }
            } else {
              this.$message.error('信息不能为空')
            }
          } else {
            return false
          }
          this.form = []
        })
      },
      changeStatus (index) {
        this.$emit('click')
        this.$store.commit('MUT_CUR', index)
      }
      // topTow () {
      //   this.$emit('click')
      //   this.$store.commit('MUT_CUR', 1)
      // }
    }
  }
</script>

<style scoped="scoped" lang="scss">
  .footer-main{
    width: 100%;
    .message{
      width:100%;
      height: 245px;
      padding-top: 60px;
      box-sizing: border-box;
      background: white;
      .message-title{
        width:1000px;
        margin:0 auto;
        text-align: center;
        color: #333;
        font-size:24px;
        font-family:PingFang-SC-Bold;
        font-weight:bold;
      }
      .message-box{
        width:1000px;
        margin:46px auto;
        .message-input{
          width: 220px;
          height: 40px;
          float: left;
          margin-left: 30px;
        }
        .message-btn{
          width: 140px;
          height: 40px;
          background: #085ECC;
          border: none;
          outline: none;
          &:hover{
            background: #4a98ff;
            transition-duration: 0.5s;
          }
        }
      }
    }
    .footer{
      width:100%;
      height:350px;
      background: #232526;
      .footer-box{
        width:1200px;
        padding: 20px 10px;
        box-sizing: border-box;
        margin: 0 auto;
        .foot-link{
          width: 100%;
          height: 1px;
          background: #656973;
        }
        .footer-m{
          width: 100%;
          height: 230px;
          /*border-bottom:1px solid #656973;*/
          .corporate{
            padding-left: 20px;
            box-sizing: border-box;
            >a{
              text-decoration: none;
            }
            .corporate-title{
              font-size: 16px;
              color:white;
            }
            .code-title{
              margin-left: 22px;
              font-size: 14px;
              color:white;
            }
            .contact-way{
              font-size: 14px;
              color:#A6A7AA;
              >a{
                font-size: 14px;
                color:#A6A7AA;
                &:hover{
                  color: white;
                }
              }
            }
            .contact-ways{
              font-size: 14px;
              color:#A6A7AA;
              &:hover{
                color: white;
              }
            }
            .code{
              width:100px;
              height:100px;
              background: white;
              >img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }
        .copyright{
          text-align: center;
          margin: 20px 0 10px 0;
          font-size: 14px;
          color:white;
        }
        .serial{
          text-align: center;
          font-size: 14px;
          color:#A6A7AA;
          a{
            color:#A6A7AA;
            &:hover{
              color:#4a98ff;
            }
          }
        }
      }
    }
  }
</style>
<style>
  .footer-main>.message>.message-box>.el-form>.el-form-item{
    width: 220px;
    height: 40px;
    float: left;
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tourist/common/Footer.vue